export default "__VITE_ASSET__DU5J_ulm__"